import { Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import PrimaryButton from "../../../../../biblio/Buttons/PrimaryButton";
import EditUnsponsoredOrphansCollapse from "./EditUnsponsoredOrphansCollapse";
import SponsorResult from "../SponsorResult";
import PaginationComponent from "../../../../../biblio/Pagination/PaginationComponent";
import {
  scroll,
  showNotitfication,
} from "../../../../../components/utils/utils";
import ModalComponent from "../../../../../biblio/Modal/ModalComponent";
import UnsponsoredPaymentMethod from "./payment/UnsponsoredPaymentMethod";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../apis/store";
import {
  setDonationLines,
  setDonationTypeId,
  setMobile,
} from "../../../../../apis/slices/moyasarSlice";
import MoyasarForm from "../../../../../components/Moyasar/MoyasarForm";
import { handleBookingLines, switchType } from "../utils";
import { toAddBooking } from "../../../../../apis/actions/sponsor.actions";
import { useNavigate } from "react-router-dom";
interface Props {
  selectedItems: any[];
  setSelctedItems: any;
  addOrRemoveItem: (n: any[]) => void;
  openModal: (v: boolean) => void;
  type: "sponsored" | "unsponsored";
  surplus_amount?: any;
}
const AllUnsponsoredOrphansWidows = ({
  selectedItems,
  setSelctedItems,
  addOrRemoveItem,
  openModal,
  type,
  surplus_amount,
}: Props) => {
  const currentRef = useRef<HTMLDivElement>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isMoyasarOpen, setDisplayMoyasar] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 10;
  useEffect(() => {
    if (selectedItems.length === 0) openModal(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems]);
  const dispatch = useDispatch<AppDispatch>();
  const sponsor = useSelector(
    (state: RootState) => state?.sponsor?.sponsorDetails,
  );
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const [booking_lines, setbooking_lines] = useState<any[]>([]);
  useEffect(() => {
    setbooking_lines(handleBookingLines(selectedItems));
  }, [selectedItems]);
  const handleAddBooking = (booking_lines: any) => {
    setIsSubmitting(true);
    dispatch(
      toAddBooking({
        payment_method: "electronic",
        sponsorship_booking_line_ids: booking_lines,
        sponsor_id: OtpId,
      }),
    ).then((res: any) => {
      const booking = res?.payload?.result;

      if (booking?.code === 200) {
        showNotitfication(booking?.message, "success");
        setTimeout(() => {
          navigate("/profile", { state: { selectedKey: "s1" } });
        }, 3000);
      } else {
        showNotitfication(res?.payload?.error?.data?.message, "error");
        setIsSubmitting(false);
      }
    });
  };
  const openMoyasar = () => {
    dispatch(setMobile(sponsor.mobile));
    const donationLine = selectedItems?.map((item: any) => ({
      beneficiary_id: item.id,
      category: switchType(
        item.selectedSponsorShipType?.label
          ? item?.selectedSponsorShipType.label
          : item?.selectedSponsorShipType,
      ),
      amount: item.amount,
      month_number: item.month.toString(),
    }));
    dispatch(setDonationLines(donationLine));
    dispatch(setDonationTypeId({ id: false, name: "كفالة" }));
    setDisplayMoyasar(true);
  };

  return (
    <>
      <Row justify={"center"} style={{ width: "100%", marginBottom: "1rem" }}>
        <p className="takaful--confirm-logout"> مراجعة الكفالات </p>
      </Row>
      <SponsorResult title="" items={selectedItems} />
      <EditUnsponsoredOrphansCollapse
        selectedItems={selectedItems}
        setSelctedItems={setSelctedItems}
        addOrRemoveItem={addOrRemoveItem}
        itemPerPage={itemPerPage}
        currentPage={currentPage}
        type={type}
        surplus_amount={surplus_amount}
      />
      <div className="takaful--pagination-container">
        {selectedItems && selectedItems?.length > itemPerPage && (
          <PaginationComponent
            active={currentPage}
            total={selectedItems?.length}
            itemPerPage={itemPerPage}
            scroll={() => scroll(currentRef)}
            setActive={(nb) => updateActive(nb)}
          />
        )}
      </div>
      <Row justify={"end"} dir="rtl" className="takaful--request-col-space">
        <Col xxl={4} xl={4} lg={6} md={6} sm={8} xs={8}>
          <PrimaryButton
            title="سداد"
            disabled={isSubmitting}
            loading={isSubmitting}
            className="takaful--sponsor-orphan-card-button"
            onClick={() =>
              type === "unsponsored"
                ? surplus_amount >=
                  selectedItems.reduce((a, b) => b.amount + a, 0)
                  ? handleAddBooking(booking_lines)
                  : setIsModalVisible(true)
                : openMoyasar()
            }
          />
        </Col>
      </Row>
      <ModalComponent
        title=""
        open={isModalVisible}
        closeOnOutsideClick={true}
        showCloseIcon={false}
        width={550}
        onClose={() => setIsModalVisible(false)}
        modalStyle={{ top: 100 }}
      >
        <UnsponsoredPaymentMethod selectedItems={selectedItems} />
      </ModalComponent>
      <MoyasarForm
        amount={selectedItems.reduce((a, b) => b.amount + a, 0)}
        description="Takaful"
        open={isMoyasarOpen}
        handleClose={() => {
          dispatch(setDonationLines([]));
          setDisplayMoyasar(false);
        }}
      />
    </>
  );
};

export default AllUnsponsoredOrphansWidows;
